export enum FlashsignerAction {
  Redeem = 'redeem',
  RedEnvelope = 'red-envelope',
  SendRedEnvelope = 'send-red-envelope',
}
